import { useState } from "react";

export const Accordion = ({ items, prefix }) => {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-white/10">
      {items.map((item, i) => (
        <div key={i} className="border-b border-white/10">
          <button
            data-testid={`${prefix}-accordion-trigger-${i}`}
            data-cta
            onClick={() => setOpen(open === i ? -1 : i)}
            className="w-full flex items-center gap-6 py-6 text-left group"
          >
            <span className="mono text-xs text-[#FFC631] shrink-0">{String(i + 1).padStart(2, "0")}</span>
            <span className="serif font-bold uppercase tracking-tight text-white text-base md:text-lg flex-1 group-hover:text-[#FE0000] transition-colors duration-200">
              {item.title}
            </span>
            <span
              className="text-[#FE0000] text-xl shrink-0 transition-transform duration-300"
              style={{ transform: open === i ? "rotate(45deg)" : "rotate(0deg)" }}
            >
              +
            </span>
          </button>
          <div
            className="overflow-hidden transition-[max-height,opacity] duration-400 ease-out"
            style={{ maxHeight: open === i ? "240px" : "0px", opacity: open === i ? 1 : 0 }}
          >
            <p data-testid={`${prefix}-accordion-body-${i}`} className="text-[15px] text-white leading-relaxed pb-6 pl-12 pr-8 max-w-2xl">
              {item.body}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
